import React from 'react';
import cn from 'classnames';
import { Visibility, Option } from '../../../types/common-types';
import Select from '../select';
import TextField, { TextFiledType } from '../textField';
import './style.scss';

export interface PhoneValue {
  countryCode: string;
  number: string;
}
export interface PhoneExtraProps {
  placeholder: { countryCode: string; number: string };
  disabledCountryCode?: boolean;
}
interface PhoneProps {
  id?: string;
  value?: PhoneValue;
  label?: string;
  error?: boolean;
  regexp?: string;
  required?: boolean;
  extra: PhoneExtraProps;
  placeholder?: string;
  options: Option[];
  helperText?: string;
  visibility?: Visibility;
  className?: string;
  styleName?: string;
  onChange?: (value: { id: string; value: object; error: boolean }) => void;
}

const Phone: React.FC<PhoneProps> = ({
  id = '',
  value = { countryCode: '', number: '' },
  label,
  options,
  regexp,
  error = false,
  extra = {
    placeholder: { countryCode: '', number: '' },
    disabledCountryCode: false,
  },
  helperText,
  required = false,
  visibility = Visibility.Visible,
  className,
  onChange,
}) => {
  const re = regexp ? new RegExp(regexp) : null;
  const checkError = (phone: PhoneValue) => {
    const stringVal = `${phone.countryCode}${phone.number}`;
    let hasError = re ? !re.test(stringVal) : false;
    if (!required && phone.countryCode === '' && phone.number === '') {
      hasError = false;
    }
    return hasError;
  };
  const onChangeHandler = (key: string, val: string) => {
    const phone = { ...value, [key]: val };
    const hasError = checkError(phone);
    if (onChange) onChange({ id, value: phone, error: hasError });
  };
  return (
    <div
      id={id}
      className={className}
      data-cy="phone"
      styleName={cn('phone', {
        error,
        hidden: visibility === Visibility.Hidden,
      })}
    >
      <div styleName="phone__label">{label}</div>
      <div styleName="phone__items">
        <Select
          id="countryCode"
          visibility={
            extra.disabledCountryCode ? Visibility.Disabled : visibility
          }
          error={error}
          value={value.countryCode}
          placeholder={extra.placeholder.countryCode}
          options={options}
          onChange={({ value: val }) => {
            onChangeHandler('countryCode', val);
          }}
        />
        <TextField
          id="number"
          className="edit"
          visibility={visibility}
          error={error}
          type={TextFiledType.Int}
          value={value.number}
          placeholder={extra.placeholder.number}
          onChange={({ value: val }) => {
            onChangeHandler('number', val);
          }}
        />
      </div>
      <div data-cy-prop="errorMsg" styleName="phone__error">
        {helperText}
      </div>
    </div>
  );
};

export default Phone;
